export default {
  created () {
    document.addEventListener('keydown', this.handleCloseByESC)
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this.handleCloseByESC)
  },
  methods: {
    handleCloseByESC (e) {
      if (e.keyCode === 27) {
        this.close()
      }
    }
  }
}
